// The published workflow definition WEB-0 drives end-to-end (seeded on the stack).
export const REFERRAL_INTAKE_API_NAME = 'referral_intake';

export const INBOUND_REFERRALS_ROUTES = {
  BASE: '/inbound-referrals',
  NEW: '/inbound-referrals/new',
  edit: (workflowId: string) => `/inbound-referrals/${workflowId}/edit`,
};

// The demographic value names this UI reads/writes — snake_case, sent verbatim. They are
// the seed's value names (app/seeds/seed_data/workflows.rb), not API field names, so
// OliveBranch leaves them alone. (The packet/attachment value names live in actionConfig's
// graph vocabulary — this UI uploads `attachments` but never reads attachment_ids /
// attachments_processed directly.)
export const VALUE_NAMES = {
  PATIENT_FIRST_NAME: 'patient_first_name',
  PATIENT_LAST_NAME: 'patient_last_name',
  PATIENT_GENDER: 'patient_gender',
  PATIENT_DOB: 'patient_dob',
} as const;

// The demographics extract_attributes produces and a person can also seed/edit, in
// display order. `label` is the entry-form label; rendered values prefer the API's
// value label (see labelForValue).
export const DEMOGRAPHIC_FIELDS = [
  { name: VALUE_NAMES.PATIENT_FIRST_NAME, label: 'First name', type: 'text' as const },
  { name: VALUE_NAMES.PATIENT_LAST_NAME, label: 'Last name', type: 'text' as const },
  { name: VALUE_NAMES.PATIENT_GENDER, label: 'Gender', type: 'text' as const },
  { name: VALUE_NAMES.PATIENT_DOB, label: 'Date of birth', type: 'date' as const },
];
